export function inIFrame(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
